import type { InterventionEditButtonProps } from "./intervention-edit-button.type";

import InterventionEdit from "@/features/Interventions/InterventionEdit";
import { useAuthorization } from "@/modules/authorization";
import { useSidePanel } from "@/modules/side-panel";
import { EditButton } from "@/ui/edit-button";

export const InterventionEditButton = ({
  intervention,
  ...buttonProps
}: InterventionEditButtonProps) => {
  const { openSidePanel } = useSidePanel();
  const { canUpdateItem } = useAuthorization();

  if (!canUpdateItem(intervention)) return null;

  const onClick = () => {
    openSidePanel({
      title: intervention.name,
      component: <InterventionEdit interventionId={intervention.id} />,
    });
  };

  return <EditButton {...buttonProps} onClick={onClick} />;
};
